import { AnyAction } from 'redux';
import { handleActions } from 'redux-actions';

// import {
//   updateUnreadReferralMessageCountAction,
//   updateReferralListAction,
// } from '@reducers/referral/ReferralActionConfig';
import { getUnreadNotificationsAction } from '@reducers/shared/SharedActionConfig';

import {
  getMyDentistListAction,
  deleteAffiliatedDentistAction,
  getAffiliatedDentistReferralsAction,
  getUnreadAffiliatedReferralsCountAction,

  updateMyNewDentistsCountAction,
} from './ClinicActionConfig';

type ReferralStatus = 'pending' | 'accepted' | 'ongoing' | 'completed' | 'declined' | 'all';
interface UnreadAffiliatedCount {
  sent: Record<ReferralStatus, number>;
  received: Record<ReferralStatus, number>;
  all: Record<ReferralStatus, number>;
}

// reducers
const defaultState = {
  affiliatedReferralList: {},
  myDentistsData: {},
  myNewDentistsCount: 0,
  unreadAffiliatedCount: {
    sent: {
      pending: 0,
      accepted: 0,
      ongoing: 0,
      completed: 0,
      declined: 0,
      all: 0,
    },
    received: {
      pending: 0,
      accepted: 0,
      ongoing: 0,
      completed: 0,
      declined: 0,
      all: 0,
    },
    all: {
      pending: 0,
      accepted: 0,
      ongoing: 0,
      completed: 0,
      declined: 0,
      all: 0,
    },
  } as UnreadAffiliatedCount,
};

type State = typeof defaultState;

// const statusArr = [ 'pending', 'accepted', 'ongoing', 'completed', 'declined' ];

const reducer = handleActions<State, AnyAction>({
  [`${getMyDentistListAction}`](state, { params, payload }: AnyAction) {
    const newPayload = payload;
    newPayload.tab = params?.status;
    return {
      ...state,
      myDentistsData: newPayload,
    };
  },
  [`${getUnreadNotificationsAction}`](state, { payload: rawPayload }: AnyAction) {
    // Phase 3 (backend): unread-notifications now answers {data: {...}} instead of it directly.
    const payload = rawPayload?.data ?? rawPayload;
    return {
      ...state,
      myNewDentistsCount: payload?.my_new_dentists,
    };
  },
  [`${updateMyNewDentistsCountAction}`](state, { payload }: AnyAction) {
    const newCount = state.myNewDentistsCount + 1;
    const newMyDentistsData: any = { ...state.myDentistsData };
    const tab = newMyDentistsData?.tab;
    if (tab === 'accepted') {
      const { data: newData } = payload.data;
      if (newMyDentistsData?.data?.length >= newMyDentistsData?.meta?.per_page) {
        // remove the last data
        newMyDentistsData?.data?.splice(9, 1);
        // push the newData above the list
        newMyDentistsData?.data?.unshift(newData);
      }
      if (newMyDentistsData?.data?.length < newMyDentistsData?.meta?.per_page) {
        // push the newData above the list
        newMyDentistsData?.data?.unshift(newData);
      }
    }
    return {
      ...state,
      myNewDentistsCount: newCount,
      myDentistsData: newMyDentistsData,
    };
  },
  [`${deleteAffiliatedDentistAction}`](state, { params }: AnyAction) {
    let newCount = state.myNewDentistsCount;
    if (params?.new) {
      newCount -= 1;
    }
    return {
      ...state,
      myNewDentistsCount: newCount,
    };
  },
  [`${getAffiliatedDentistReferralsAction}`](state: State, { params, payload }: AnyAction) {
    const newPayload = payload;
    newPayload.tab = params?.status;
    newPayload.filter = params?.filter;
    return {
      ...state,
      affiliatedReferralList: newPayload,
    };
  },
  [`${getUnreadAffiliatedReferralsCountAction}`](state: State, { payload: rawPayload }: AnyAction) {
    // Phase 3 (backend): now answers {data: {...}} instead of it directly.
    const payload = rawPayload?.data ?? rawPayload;
    return {
      ...state,
      unreadAffiliatedCount: payload?.affiliated_dentist_referrals,
    };
  },
  // [`${updateUnreadReferralMessageCountAction}`](state: State, { payload }: AnyAction) {
  //   const userId = payload?.userId;
  //   const payloadData = payload?.data;
  //   const lastMessagesSent = payloadData?.referred_details?.last_message_sent || [];
  //   const lastMessageCount = payloadData?.referred_details?.last_message_sent?.length || 0;
  //   const refStatus = payloadData?.referred_details?.status;
  //   // const sent = payloadData?.referred_details?.created_by === userId;
  //   const received = payloadData?.referred_details?.created_by !== userId;

  //   let newCount: any = state.unreadAffiliatedCount;
  //   let newReferralList: any = state.affiliatedReferralList;

  //   if (!newReferralList?.data) {
  //     return {
  //       ...state,
  //     };
  //   }

  //   const { data }: any = newReferralList;

  //   const referralIndex = data?.length > 0 && data
  //     .findIndex((r: any) => r.id === payloadData.referral_id);

  //   // if the user is in another tab/page, just update the count
  //   if (referralIndex === -1) {
  //     // if there is only one unread message, update here
  //     if (lastMessageCount === 1
  //       || (lastMessageCount === 2 && lastMessagesSent[1]?.reads?.read_by === userId)) {
  //       if (refStatus && statusArr.indexOf(refStatus) !== -1) {
  //         if (received) {
  //           newCount = {
  //             ...newCount,
  //             received: {
  //               ...newCount.received,
  //               [refStatus as ReferralStatus]: state.unreadAffiliatedCount
  //                 .received[refStatus as ReferralStatus] + 1,
  //               all: state.unreadAffiliatedCount.received.all + 1,
  //             },
  //             // all of regardless if sent or received
  //             all: {
  //               ...newCount.all,
  //               [refStatus as ReferralStatus]: state.unreadAffiliatedCount
  //                 .all[refStatus as ReferralStatus] + 1,
  //               all: state.unreadAffiliatedCount.all.all + 1,
  //             },
  //           };

  //           return {
  //             ...state,
  //             unreadAffiliatedCount: newCount,
  //           };
  //         }

  //         // for sent referrals
  //         newCount = {
  //           ...newCount,
  //           sent: {
  //             ...newCount.sent,
  //             [refStatus as ReferralStatus]: state.unreadAffiliatedCount
  //               .sent[refStatus as ReferralStatus] + 1,
  //             all: state.unreadAffiliatedCount.sent.all + 1,
  //           },
  //           // all of regardless if sent or received
  //           all: {
  //             ...newCount.all,
  //             [refStatus as ReferralStatus]: state.unreadAffiliatedCount
  //               .all[refStatus as ReferralStatus] + 1,
  //             all: state.unreadAffiliatedCount.all.all + 1,
  //           },
  //         };

  //         return {
  //           ...state,
  //           unreadAffiliatedCount: newCount,
  //         };
  //       }
  //     }

  //     return {
  //       ...state,
  //       unreadAffiliatedCount: newCount,
  //     };
  //   }

  //   // else update the referral data message record as well
  //   // will enter this validation if the current page/tab
  //   // opened is the referral list/if the referral list has a value
  //   if (referralIndex >= 0 && data?.length > 0) {
  //     const [ updatedData ] = data.splice(referralIndex, 1);

  //     // Update the message with the new data
  //     updatedData.message = payloadData;

  //     // Add the updated data to the beginning of the array
  //     data.unshift(updatedData);

  //     newReferralList = {
  //       ...newReferralList,
  //       data,
  //     };
  //   }
  //   if (lastMessageCount === 1
  //     || (lastMessageCount === 2 && lastMessagesSent[1]?.reads?.read_by === userId)) {
  //     if (refStatus && statusArr.indexOf(refStatus) !== -1) {
  //       if (received) {
  //         newCount = {
  //           ...newCount,
  //           received: {
  //             ...newCount.received,
  //             [refStatus as ReferralStatus]: state.unreadAffiliatedCount
  //               .received[refStatus as ReferralStatus] + 1,
  //             all: state.unreadAffiliatedCount.received.all + 1,
  //           },
  //           // all of regardless if sent or received
  //           all: {
  //             ...newCount.all,
  //             [refStatus as ReferralStatus]: state.unreadAffiliatedCount
  //               .all[refStatus as ReferralStatus] + 1,
  //             all: state.unreadAffiliatedCount.all.all + 1,
  //           },
  //         };

  //         return {
  //           ...state,
  //           affiliatedReferralList: newReferralList,
  //           unreadAffiliatedCount: newCount,
  //         };
  //       }

  //       // for sent referrals
  //       newCount = {
  //         ...newCount,
  //         sent: {
  //           ...newCount.sent,
  //           [refStatus as ReferralStatus]: state.unreadAffiliatedCount
  //             .sent[refStatus as ReferralStatus] + 1,
  //           all: state.unreadAffiliatedCount.sent.all + 1,
  //         },
  //         // all of regardless if sent or received
  //         all: {
  //           ...newCount.all,
  //           [refStatus as ReferralStatus]: state.unreadAffiliatedCount
  //             .all[refStatus as ReferralStatus] + 1,
  //           all: state.unreadAffiliatedCount.all.all + 1,
  //         },
  //       };

  //       return {
  //         ...state,
  //         affiliatedReferralList: newReferralList,
  //         unreadAffiliatedCount: newCount,
  //       };
  //     }
  //   }

  //   return {
  //     ...state,
  //     unreadAffiliatedCount: newCount,
  //     affiliatedReferralList: newReferralList,
  //   };
  // },
  // [`${updateReferralListAction}`](state: State, { payload }: AnyAction) {
  //   const { data: newData } = payload.data;
  //   const userId = payload?.userId;
  //   const newReferralList: any = { ...state.affiliatedReferralList };
  //   const tab = newReferralList?.tab;
  //   const filter = newReferralList?.filter;
  //   const sent = newData?.created_by === userId;
  //   const received = newData?.created_by !== userId;
  //   const lastMessagesSent = newData?.last_message_sent || [];
  //   const lastMessageCount = newData?.last_message_sent?.length || 0;
  //   let newCount: any = state.unreadAffiliatedCount;

  //   // if status is not pending, update the data
  //   if (newData?.status !== 'pending' && newReferralList?.data) {
  //     const { data: refData }: any = newReferralList;

  //     const referralIndex = refData.findIndex((r: any) => r.id === newData.id);

  //     // update the count if the status has been changed and has more
  //     // more than 1 last message count and has never been read
  //     if (lastMessageCount === 2 && !lastMessagesSent[1]?.reads?.id) {
  //       const lastMessageSent = newData?.last_message_sent;
  //       const statusHistories = newData?.status_histories;
  //       // always index 1 since it will only have an array of 2 data
  //       const previousMessage = lastMessageSent[1];
  //       const previousStatus = statusHistories[1];

  //       if (statusArr.indexOf(previousStatus?.status) !== -1
  //       && statusArr.indexOf(newData?.status) !== -1 && !previousMessage?.reads?.id) {
  //         // received referrals
  //         if (received) {
  //           newCount = {
  //             ...newCount,
  //             received: {
  //               ...newCount.received,
  //               // add 1 to the new status
  //               [newData?.status as ReferralStatus]: state.unreadAffiliatedCount
  //                 .received[newData?.status as ReferralStatus] + 1,
  //               // subtract 1 to the previous status
  //               [previousStatus?.status as ReferralStatus]: state.unreadAffiliatedCount
  //                 .received[previousStatus?.status as ReferralStatus] - 1,
  //             },
  //             // all of regardless if sent or received
  //             all: {
  //               ...newCount.all,
  //               [newData?.status as ReferralStatus]: state.unreadAffiliatedCount
  //                 .all[newData?.status as ReferralStatus] + 1,
  //               [previousStatus?.status as ReferralStatus]: state.unreadAffiliatedCount
  //                 .all[previousStatus?.status as ReferralStatus] - 1,
  //               // all: state.unreadCount.all.all - 1,
  //             },
  //           };
  //         }
  //         // sent referrals
  //         if (sent) {
  //           newCount = {
  //             ...newCount,
  //             sent: {
  //               ...newCount.sent,
  //               // add 1 to the new status
  //               [newData?.status as ReferralStatus]: state.unreadAffiliatedCount
  //                 .sent[newData?.status as ReferralStatus] + 1,
  //               // subtract 1 to the previous status
  //               [previousStatus?.status as ReferralStatus]: state.unreadAffiliatedCount
  //                 .sent[previousStatus?.status as ReferralStatus] - 1,
  //             },
  //             // all of regardless if sent or received
  //             all: {
  //               ...newCount.all,
  //               [newData?.status as ReferralStatus]: state.unreadAffiliatedCount
  //                 .all[newData?.status as ReferralStatus] + 1,
  //               [previousStatus?.status as ReferralStatus]: state.unreadAffiliatedCount
  //                 .all[previousStatus?.status as ReferralStatus] - 1,
  //               // all: state.unreadCount.all.all - 1,
  //             },
  //           };
  //         }
  //       }
  //     }

  //     // update data list if the user's tab is equal to the data status
  //     // (ongoing, completed, declined)
  //     if (tab === newData?.status) {
  //       // it means the data is not yet visible in the list, add it
  //       if (referralIndex === -1) {
  //         if (newReferralList?.data?.length >= newReferralList?.meta?.per_page) {
  //         // remove the last data
  //           newReferralList?.data?.splice(9, 1);
  //           // push the newData above the list
  //           newReferralList?.data?.unshift(newData);
  //         }
  //         if (newReferralList?.data?.length < newReferralList?.meta?.per_page) {
  //         // push the newData above the list
  //           newReferralList?.data?.unshift(newData);
  //         }
  //         return {
  //           ...state,
  //           unreadAffiliatedCount: newCount,
  //           affiliatedReferralList: newReferralList,
  //         };
  //       }
  //     }
  //     // remove data with pending/completed status real time in other tabs
  //     if ([ 'pending', 'ongoing' ].indexOf(tab) !== -1) {
  //       // if the new data is equal to decline, completed or read, place it in the correct tab
  //       if ([ 'accepted', 'completed', 'declined' ].indexOf(newData?.status) !== -1
  // & referralIndex !== -1) {
  //       // it means the data is visible and needs to be removed from the list
  //         const filteredData = refData.filter((r: any) => r.id !== newData.id);
  //         newReferralList.data = filteredData;
  //         return {
  //           ...state,
  //           unreadAffiliatedCount: newCount,
  //           affiliatedReferralList: newReferralList,
  //         };
  //       }
  //     }

  //     // if in the referrals tab, update the list status if the index is existing
  //     if (referralIndex !== -1) {
  //       refData[referralIndex].status = newData?.status;
  //       return {
  //         ...state,
  //         unreadAffiliatedCount: newCount,
  //         affiliatedReferralList: newReferralList,
  //       };
  //     }

  //     return {
  //       ...state,
  //       unreadAffiliatedCount: newCount,
  //       affiliatedReferralList: state.affiliatedReferralList,
  //     };
  //   }

  //   // if the status is pending, add the newly created in the list
  //   // update data list if the user is in the all/pending tab
  //   if ([ 'all', 'pending' ].indexOf(tab) !== -1
  // && [ 'all', 'received' ].indexOf(filter) !== -1) {
  //     if (newReferralList?.data?.length >= newReferralList?.meta?.per_page) {
  //       // remove the last data
  //       newReferralList?.data?.splice(9, 1);
  //       // push the newData above the list
  //       newReferralList?.data?.unshift(newData);
  //     }
  //     if (newReferralList?.data?.length < newReferralList?.meta?.per_page) {
  //       // push the newData above the list
  //       newReferralList?.data?.unshift(newData);
  //     }
  //   }

  //   // update received count
  //   newCount = {
  //     ...newCount,
  //     received: {
  //       ...newCount.received,
  //       pending: state.unreadAffiliatedCount.received.pending + 1,
  //       all: state.unreadAffiliatedCount.received.all + 1,
  //     },
  //     // all of regardless if sent or received
  //     all: {
  //       ...newCount.all,
  //       pending: state.unreadAffiliatedCount.all.pending + 1,
  //       all: state.unreadAffiliatedCount.all.all + 1,
  //     },
  //   };

  //   return {
  //     ...state,
  //     unreadAffiliatedCount: newCount,
  //     affiliatedReferralList: newReferralList,
  //   };
  // },
}, defaultState);

export default reducer;
